import { Image } from '../Image/Image';
import { Title } from '../Title/Title';
import styles from './UpsaleTransformation.module.scss';
export const UpsaleTransformation = ({content})=>{
  if(!content){
    return;
  }
  const {title,image} = content;
  return (
    <div className={styles.wrapper}>
      {title && <Title dangerouslySetInnerHTML={{ __html:title }} tag="h2" className={styles.title}/>}
      {image && <Image className={styles.image} src={image}/>}
    </div>
  )
}